<template>
    <div class="exam-record-page">
        <div class="list-wrap">
            <div v-if="!loading && finished && examRecords.length === 0" class="empty-state">
                <van-empty description="暂无考试记录" />
            </div>
            <van-list
                v-else
                v-model="loading"
                :finished="finished"
                @load="onLoad"
            >
                <div
                    class="record-item"
                    :class="{ clickable: item.totalScore >= 0 }"
                    v-for="(item, index) in examRecords"
                    :key="item.id || index"
                    @click="handleRecordClick(item)"
                >
                    <div class="record-header">
                        <span class="record-title">{{ item.testPaperTitle || '--' }}</span>
                        <span class="record-status" :class="{ pending: item.state === '待批阅' }">
                            {{ item.state || '已完成' }}
                        </span>
                    </div>

                    <div class="record-row">
                        <span class="label">考试时间</span>
                        <span class="value">{{ item.startTime || '--' }}</span>
                    </div>
                    <div class="record-row">
                        <span class="label">考试用时</span>
                        <span class="value">{{ calculateDuration(item.startTime, item.endTime) }}</span>
                    </div>
                    <div class="record-row">
                        <span class="label">得分</span>
                        <span v-if="item.state === '答题中'" class="value">--</span>
                        <div v-else-if="item.state === '待批阅'" class="score-badge score-pending">待批阅</div>
                        <div v-else class="score-badge" :class="getScoreClass(item.totalScore)">{{ item.totalScore }}</div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { getMyAnswers } from '@/api/index.js';

export default {
    name: 'ExamRecord',
    data() {
        return {
            pageNum: 1,
            pageSize: 20,
            loading: false,
            finished: false,
            examRecords: []
        };
    },
    mounted() {
        this.loadRecords(false);
    },
    methods: {
        onLoad() {
            this.loadRecords(true);
        },
        async loadRecords(isLoadMore = false) {
            if (this.loading || this.finished) return;
            this.loading = true;
            try {
                const res = await getMyAnswers({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                });
                const records = res.data?.records || [];
                const total = res.data?.total || 0;
                this.examRecords = isLoadMore ? [...this.examRecords, ...records] : records;
                if (this.examRecords.length >= total || records.length < this.pageSize) {
                    this.finished = true;
                } else {
                    this.pageNum += 1;
                }
            } finally {
                this.loading = false;
            }
        },
        calculateDuration(startTime, endTime) {
            if (!startTime || !endTime) return '--';
            const start = moment(startTime);
            const end = moment(endTime);
            if (!start.isValid() || !end.isValid()) return '--';
            const duration = moment.duration(end.diff(start));
            const hours = Math.floor(duration.asHours());
            const minutes = duration.minutes();
            const seconds = duration.seconds();
            if (hours > 0) {
                return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            }
            return `${minutes}:${String(seconds).padStart(2, '0')}`;
        },
        getScoreClass(score) {
            if (score >= 90) return 'score-excellent';
            if (score >= 80) return 'score-good';
            if (score >= 60) return 'score-pass';
            return 'score-fail';
        },
        handleRecordClick(item) {
            if (!item.id) {
                this.$toast('缺少答卷ID');
                return;
            }
            this.$router.push({
                path: '/my/exam-result-detail',
                query: { answerId: item.id }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.exam-record-page {
    min-height: 100vh;
    background: #eef7f8;
    padding: 12px;
    box-sizing: border-box;
}

.list-wrap {
    padding-bottom: 16px;
}

.record-item {
    background: #fff;
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 12px;
}

.record-item.clickable:active {
    opacity: 0.75;
}

.record-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.record-title {
    font-size: 16px;
    color: #333;
    font-weight: 600;
}

.record-status {
    font-size: 12px;
    color: #46ccdc;
}

.record-status.pending {
    color: #ff9800;
}

.record-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 6px;
}

.label {
    color: #9f9f9f;
}

.value {
    color: #333;
}

.score-badge {
    min-width: 48px;
    height: 24px;
    padding: 0 10px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}

.score-excellent {
    background: linear-gradient(135deg, #00d4ff, #00a8cc);
}

.score-good {
    background: linear-gradient(135deg, #4fc3f7, #29b6f6);
}

.score-pass {
    background: linear-gradient(135deg, #ffb74d, #ff9800);
}

.score-fail {
    background: linear-gradient(135deg, #ff7043, #ff5722);
}

.score-pending {
    background: #ff9800;
}
</style>
